import { makeAutoObservable } from 'mobx'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { SmartCallFlowBuilderStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder'

export class SmartCallEditStore {
  smartCallFlowBuilderStore
  constructor(public readonly entities: IEntitiesStore, private id: number) {
    this.smartCallFlowBuilderStore = new SmartCallFlowBuilderStore(this.entities, this)
    makeAutoObservable(this)
  }

  init = () => {
    this.entities.inboxesStore.getById(this.id, true)
  }

  get inbox() {
    const inbox = this.entities.inboxesStore.getOrganizationItem(this.id)
    if (inbox instanceof Inbox) {
      return inbox
    }
    return null
  }

  onActivate = () => {
    const isValid = this.smartCallFlowBuilderStore.validateForPublish()
    if (!isValid) {
      return
    }
  }
}
